const gcp_appengine_id = 'smart-operator-dev'
const gcp_storage_endpoint = `https://storage.googleapis.com/${gcp_appengine_id}.appspot.com/`
const orchestration_context = '/rmsservices/adminorch/v1'
const relativity_sso_config = {
    clientId: '54af54fc-d820-4c78-9793-45383bcb0c71',
    authority: 'https://login.microsoftonline.com/1e3b0b73-abad-4e5c-b306-1441c5de91e3'
}

const intel_sso_config = {
  clientId: '5e105630-6e18-46f3-a7a1-e4cc71721367',
  authority: 'https://login.microsoftonline.com/46c98d88-e344-4ed4-8496-4ed7712e255d'
}

export const environment = {
  production: true,
  // Relative: the API is served on the portal's own hostname, so one build works on any hostname (beta and real).
  baseUrl: orchestration_context,
  gcp_storage_endpoint,
  token_prefix: '[sop-admin-staging]',
  msalConfig: {
    auth: relativity_sso_config
  },
  apiConfig: {
    scopes: ['openid', 'profile'],
    uri: 'https://graph.microsoft.com/v1.0/me'
  }
}
